import React, { useState } from 'react'
import HeroSection from '../../molecules/DDX/HeroSection'
import IntroAnimation from '../../organisms/IntroAnimation/IntroAnimation'
import Footer from '../../organisms/Footer/Footer'
import colors from '../../theme/color'
import Vision from '../../molecules/Vision/Vision'
import CoreCapabilities from '../../molecules/CoreCapabilities/CoreCapabilities'
import Impact from '../../atoms/Impact/Impact'
import WhatWeBuild from '../../atoms/whatwebuild/whatwebuild'
import Testimonial from '../../molecules/Testimonial/Testimonial'
import Message from '../../molecules/Message/Message'
import Questions from '../../molecules/Questions/Questions'

const DDXPage = () => {
    const [startAnimation, setStartAnimation] = useState(false)
  
    // 🔥 FORCE RE-MOUNT INTRO EVERY VISIT
    const [introKey] = useState(() => Date.now())
  return (
    <main className="min-h-screen text-white" style={{ backgroundColor: colors.ddxPageBg }}>
       <IntroAnimation
              key={introKey}
              words={['DDX']}
              wordColors={['#f8f8f8', '#ffffff']}
              backgroundGradient={{
                top: '#2B0946',
                bottom: '#5E0F9B',
              }}
              onHeroStart={() => setStartAnimation(true)}
            />
      <HeroSection />
      <Vision />
      <CoreCapabilities/>
      <WhatWeBuild />
      <Impact />
      <div
        className="w-full py-10 md:py-14"
        style={{ background: colors.ddxSectionGradient }}
      >
        <Testimonial className="mx-auto mb-20 max-w-[90%]" showHeader themeColor="ddxtheme" />
        <div className="mb-10 px-4 md:px-8 2xl:mx-20 xl:px-12">
          <div className="grid w-full grid-cols-1 gap-5 xl:min-h-[620px] 2xl:min-h-[710px] lg:grid-cols-[1fr_1fr] xl:grid-cols-[1fr_2fr]">
            <Message themeColor="ddxtheme" />
            <Questions themeColor="ddxtheme" />
          </div>
        </div>
      </div>
      <Footer />
    </main>
  )
}

export default DDXPage
